import React from 'react';
import { useParams, Link } from 'react-router-dom';
import logo from '../../assets/Logo.webp';
import logoText from '../../assets/logo-text-only.webp';

const GUIDES = {
  whatsapp: {
    title: 'Cómo conectar WhatsApp Business',
    color: '#25d366',
    colorBg: 'rgba(37,211,102,0.08)',
    colorBorder: 'rgba(37,211,102,0.2)',
    steps: [
      {
        title: 'Crea tu cuenta de Facebook Business',
        description: 'Necesitas un Meta Business Manager para administrar tu número de WhatsApp Business. Si ya tienes uno, puedes saltar este paso.',
        url: 'https://business.facebook.com/',
        urlLabel: 'Ir a business.facebook.com',
      },
      {
        title: 'Verifica tu cuenta de WhatsApp Business',
        description: 'Tu cuenta de WhatsApp Business debe estar verificada por Meta. Esto se hace desde el Meta Business Manager en Configuración → Seguridad → Verificación.',
        url: 'https://www.facebook.com/business/help/2058515294227817',
        urlLabel: 'Cómo verificar tu cuenta de WhatsApp Business',
      },
      {
        title: 'Agrega un método de pago en Meta Business Manager',
        description: 'Meta requiere un método de pago activo para habilitar la API de WhatsApp Business. Ve a Meta Business Suite → Configuración → Métodos de pago.',
        url: 'https://www.facebook.com/business/help/915454841921082',
        urlLabel: 'Cómo agregar un método de pago',
      },
      {
        title: 'Prepara un número de teléfono exclusivo',
        description: 'El número NO puede estar registrado en WhatsApp (personal o Business App). Puede ser un número móvil o fijo. Si ya lo usas en WhatsApp, primero debes eliminarlo de esa cuenta.',
        url: 'https://developers.facebook.com/docs/whatsapp/phone-numbers',
        urlLabel: 'Requisitos del número de teléfono (Meta)',
      },
      {
        title: 'Ten acceso al número para recibir el OTP',
        description: 'Durante el proceso Meta te enviará un código de verificación por SMS o llamada al número que registres. Asegúrate de tener acceso en ese momento.',
        url: 'https://developers.facebook.com/docs/whatsapp/phone-numbers',
        urlLabel: 'Requisitos del número de teléfono (Meta)',
      },
      {
        title: 'Define el nombre de tu empresa en WhatsApp',
        description: 'Este es el nombre que tus clientes verán en WhatsApp al recibir mensajes. Debe representar tu marca y cumplir las políticas de Meta.',
        url: 'https://www.facebook.com/business/help/338047025165344',
        urlLabel: 'Políticas de nombre para mostrar',
      },
      {
        title: 'Vuelve al wizard y haz clic en Conectar',
        description: 'Con todo lo anterior listo, regresa a la pantalla anterior y haz clic en "Conectar" en WhatsApp. Se abrirá una ventana de Meta donde debes seguir los pasos para vincular tu número.',
        url: null,
        urlLabel: null,
      },
    ],
  },
  instagram: {
    title: 'Cómo conectar Instagram Business',
    color: '#e1306c',
    colorBg: 'rgba(225,48,108,0.08)',
    colorBorder: 'rgba(225,48,108,0.2)',
    steps: [
      {
        title: 'Convierte tu cuenta Instagram a Business o Creator',
        description: 'Instagram solo permite mensajería de API en cuentas Business o Creator. En la app de Instagram: Ajustes → Tipo de cuenta y herramientas → Cambiar a cuenta profesional.',
        url: null,
        urlLabel: null,
      },
      {
        title: 'Vincula tu Instagram a una Página de Facebook',
        description: 'La cuenta de Instagram debe estar conectada a una Página de Facebook. Ve a Ajustes → Cuenta → Páginas vinculadas de Facebook.',
        url: 'https://www.facebook.com/business/help/898752960195806',
        urlLabel: 'Cómo vincular Instagram a una página de Facebook',
      },
      {
        title: 'Asegúrate de tener un Meta Business Manager',
        description: 'La Página de Facebook debe estar en un Meta Business Manager. Si no tienes uno, créalo en business.facebook.com y añade tu Página.',
        url: 'https://business.facebook.com/',
        urlLabel: 'Ir a business.facebook.com',
      },
      {
        title: 'Habilita la mensajería en Instagram',
        description: 'Ve a Ajustes → Privacidad → Mensajes y activa "Permitir solicitudes de mensajes de otras personas".',
        url: 'https://developers.facebook.com/docs/messenger-platform/instagram',
        urlLabel: 'Requisitos de mensajería de Instagram (Meta)',
      },
      {
        title: 'Vuelve al wizard y haz clic en Conectar',
        description: 'Con todo lo anterior listo, regresa a la pantalla anterior y haz clic en "Conectar" en Instagram. Se abrirá una ventana de Meta para autorizar el acceso.',
        url: null,
        urlLabel: null,
      },
    ],
  },
};

export default function RedeemGuideView() {
  const { channel } = useParams();
  const guide = GUIDES[channel];

  if (!guide) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#09090f', color: '#888' }}>
        Canal no encontrado.{' '}
        <Link to="/redeem" style={{ color: '#a78bfa', marginLeft: 8 }}>Volver</Link>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: 'radial-gradient(ellipse at 50% 0%, #1e0a3c 0%, #09090f 60%)', padding: '40px 16px' }}>
      {/* Header */}
      <div style={{ maxWidth: 600, margin: '0 auto 32px' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
          <img src={logo} alt="Zenit AI" style={{ height: 36, width: 'auto' }} />
          <img src={logoText} alt="Zenit AI" style={{ height: 20, width: 'auto' }} />
        </div>

        <div style={{ marginBottom: 16 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: guide.colorBg, border: `1px solid ${guide.colorBorder}`, borderRadius: 999, padding: '4px 14px' }}>
            <div style={{ width: 8, height: 8, borderRadius: '50%', background: guide.color }} />
            <span style={{ fontSize: 12, color: guide.color, fontWeight: 600 }}>Guía de configuración</span>
          </div>
        </div>

        <h1 style={{ fontSize: 24, fontWeight: 700, color: '#e2e2f0', margin: '0 0 8px' }}>{guide.title}</h1>
        <p style={{ fontSize: 14, color: '#6b6b8a', margin: 0 }}>Sigue estos pasos antes de hacer clic en "Conectar" en el wizard.</p>
      </div>

      {/* Steps */}
      <div style={{ maxWidth: 600, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 16 }}>
        {guide.steps.map((step, i) => (
          <div key={i} style={{ display: 'flex', gap: 16 }}>
            {/* Number */}
            <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{
                width: 32, height: 32, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: i === guide.steps.length - 1 ? 'rgba(124,58,237,0.2)' : guide.colorBg,
                border: `1.5px solid ${i === guide.steps.length - 1 ? '#7c3aed' : guide.color}`,
                color: i === guide.steps.length - 1 ? '#a78bfa' : guide.color,
                fontSize: 13, fontWeight: 700,
              }}>
                {i + 1}
              </div>
              {i < guide.steps.length - 1 && (
                <div style={{ width: 1, flex: 1, minHeight: 20, background: 'rgba(255,255,255,0.06)', margin: '6px 0' }} />
              )}
            </div>

            {/* Content */}
            <div style={{ flex: 1, paddingBottom: i < guide.steps.length - 1 ? 8 : 0 }}>
              <div style={{ fontSize: 15, fontWeight: 600, color: '#e2e2f0', marginBottom: 6 }}>{step.title}</div>
              <div style={{ fontSize: 13, color: '#6b6b8a', lineHeight: 1.6, marginBottom: step.url ? 10 : 0 }}>{step.description}</div>
              {step.url && (
                <a href={step.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: '#a78bfa', fontWeight: 600, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                  {step.urlLabel} ↗
                </a>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Back link */}
      <div style={{ maxWidth: 600, margin: '32px auto 0', textAlign: 'center' }}>
        <Link to="/redeem" style={{ fontSize: 13, color: '#555', textDecoration: 'none' }}>
          ← Volver al wizard
        </Link>
      </div>
    </div>
  );
}
